import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Globals } from 'app/_globals';
import { ContractorManagerService } from 'app/_services/contractor-manager.service';
import { ContractorService } from 'app/_services/contractor.service';
import { RolePermissionService, SkylarkPermission } from 'app/_services/role-permission.service';

@Component({
  selector: 'contractor-details',
  templateUrl: './contractor-details.component.html'
})
export class ContractorDetailsComponent implements OnInit {
  public missingSiteOwnerLink = false;

  public routeRole: any;
  public selectedContractorId: any;

  public tabitems: any[] = [];
  public selectedContractor: any;
  public isReadOnly: boolean;

  public siteOwnerSkylarkUserId: any;

  constructor(
    public contractorService: ContractorService,
    public globals: Globals,
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    public contractorManagerService: ContractorManagerService,
    private rolePermissionService: RolePermissionService,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedContractorId = params.contractorId;;
    });

    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      { path: '/' + this.routeRole + '/contractors/', title: 'All Contractors', class: 'back-link' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/details', title: 'Details' },
      ...(this.routeRole === 'authorising-officer' ? [] : [
        { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/certificates', title: 'Certificates' },
      ]),
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/workers', title: 'Workers' },
    ];

    this.isReadOnly = !this.rolePermissionService.hasPermission(SkylarkPermission.WRITE__CONTRACTORS);

    this.siteOwnerSkylarkUserId = this.globals.siteOwnerUsers[0].skylarkUserId;
  }

  ngOnInit() {
    this.getSelectedContractor(this.selectedContractorId);
  }

  public getSelectedContractor(id) {
    this.contractorService.getContractorById(id).subscribe((result: any) => {
      this.selectedContractor = result;

      const mso = result.maintenanceSiteOwners.find(mso => {
        return mso.siteOwnerUser.skylarkUserId === this.siteOwnerSkylarkUserId
      })

      if (mso) {
        this.selectedContractor.competencies = mso.maintenanceSiteOwnerCompetencyTypes.map(c => {
          return {
            label: c.competencyType.value,
            status: c.status,
          };
        });
      } else {
        this.missingSiteOwnerLink = true;
      }
    });
  }
}
